<app-page-title title="Indicateurs"></app-page-title>
@if(isRealtor){
<app-analytics-realtors
  class="container-fluid d-inline-block"
></app-analytics-realtors>
} @else {
<app-analytics class="container-fluid d-inline-block"></app-analytics>
}
